// extracted by mini-css-extract-plugin
export default {"card":"legalCards_card__mX-HX","icon":"legalCards_icon__9NMJH","button":"legalCards_button__E+TWm"};